
@if (progressRate) {
  <div class="tw-flex tw-justify-between">
    <div>
      <p class="tw-text-xl tw-font-semibold"[innerHTML]="'user_management.create_user.complete_your_profile' | translate"></p>
    </div>
    <div class="tw-flex tw-gap-1">
      <div class="tw-mb-5 tw-h-2 tw-rounded-full tw-bg-gray-200 tw-w-80 tw-mt-[10px]">
        <div class="tw-h-2 tw-rounded-full tw-bg-[#0F93CC] tw-w-[25%]"></div>
      </div>
      <p class="tw-text-xl">{{progressRate}}%</p>
    </div>
  </div>
}

<form [formGroup]="form">
  <div class="tw-flex tw-flex-col md:tw-flex-row ">
    <div class=" tw-w-full  md:tw-w-1/2 tw-flex tw-flex-wrap">
      @for (controlName of controls; track controlName) {
        <div [class]="'tw-flex tw-flex-col tw-flex-auto tw-mx-3 xl:tw-mx-5 tw-py-3 tw-w-full xl:tw-w-' + getColClass(controlName)" >
          @switch (controlName) {
            @case ('language') {
              <label class="tw-text-main-text tw-text-xs" [ngClass]="{'tw-text-detractors' : !form.get(controlName).valid && form.get(controlName).touched }">{{ 'user_management.create_user.personal_info.' + controlName | translate }}<span class="tw-text-red-500">*</span></label>
              <select class="tw-h-[34px] tw-my-2 tw-rounded-md tw-border tw-border-border-light-gray tw-bg-fff disabled:tw-bg-main-disabled disabled:tw-text-disabled-font tw-pt-1" [formControlName]="controlName" [ngClass]="{'tw-border-detractors' : !form.get(controlName).valid && form.get(controlName).touched }">
                @for (lang of languages; track lang.id) {
                  <option [ngValue]="lang.id">{{ 'languages.iso.' + lang.code | translate }}</option>
                }
              </select>
            }

            @case (controlName === 'department' || controlName === 'jobType' ? controlName : '') {
              <label class="tw-text-main-text tw-text-xs" [ngClass]="{'tw-text-detractors' : !form.get(controlName).valid && form.get(controlName).touched }">{{ 'user_management.create_user.personal_info.' + controlName | translate }}<span class="tw-text-red-500">*</span></label>
              <select class="tw-h-[34px] tw-my-2 tw-rounded-md tw-border tw-border-border-light-gray tw-bg-fff disabled:tw-bg-main-disabled disabled:tw-text-disabled-font tw-pt-1" [formControlName]="controlName" [ngClass]="{'tw-border-detractors' : !form.get(controlName).valid && form.get(controlName).touched }">
                @for (item of (controlName === 'department' ? departments : (controlName === 'jobType') ? roles : rolesList); track item.id) {
                  <option [ngValue]="item.id">{{ 'models.user_profile.roles.' + item.id | translate }}</option>
                }
              </select>
            }

            @case ('role') {
              <div class="tw-flex tw-justify-between">
                <label class="tw-text-main-text tw-text-xs" [ngClass]="{'tw-text-detractors' : !form.get(controlName).valid && form.get(controlName).touched }">{{ 'user_management.create_user.personal_info.' + controlName | translate }}<span class="tw-text-red-500">*</span></label>
                <label class="tw-text-[#0F93CC] tw-text-xs tw-underline tw-cursor-pointer" (click)="openRolesActionsModal()">{{ 'user_management.create_user.whats_this' | translate }}</label>
              </div>
              <select class="tw-h-[34px] tw-my-2 tw-rounded-md tw-border tw-border-border-light-gray tw-bg-fff disabled:tw-bg-main-disabled disabled:tw-text-disabled-font tw-pt-1" [formControlName]="controlName" [ngClass]="{'tw-border-detractors' : !form.get(controlName).valid && form.get(controlName).touched }">
                @for (item of (controlName === 'department' ? departments : (controlName === 'jobType') ? roles : rolesList); track item.id) {
                  <option [ngValue]="item.id">{{ 'models.user_profile.roles.' + item.id | translate }}</option>
                }
              </select>
            }

            @case (controlName === 'cellphone' || controlName === 'phone' ? controlName : '') {
              <label class="tw-text-main-text tw-text-xs">{{ 'user_management.create_user.personal_info.' + controlName | translate }}</label>
              <div class="tw-relative tw-w-full">
                <!-- Contenedor del botón y el input -->
                <div class="tw-flex tw-items-center tw-border tw-border-border-light-gray tw-rounded-md tw-bg-slate-100 tw-my-2">

                  <img
                  [src]="imagesPath + (selectedCode?.code2?.toLowerCase() ?? 'xx') + '.svg'"
                  alt="Flag"
                  class="tw-h-4 tw-w-4 tw-mx-2"
                />

                  <!-- Input para búsqueda y selección del código de país -->
                <input
                class="tw-w-[30%] !tw-min-w-[61px] tw-h-[26px] tw-rounded-md tw-border-none tw-px-2 tw-bg-slate-100"
                type="text"
                formControlName="cellphoneCountryCode"
                (focus)="toggleDropdown()"
                (input)="filterCodes()"
                placeholder="{{ 'commons.search_country_code' | translate }}"
                />

                <!-- Lista desplegable de códigos de país -->
                @if (isDropdownOpen) {
                  <ul class="tw-absolute tw-top-full tw-left-0 tw-bg-white tw-shadow-lg tw-mt-1 tw-rounded-md tw-w-2/4 tw-max-h-60 tw-overflow-auto tw-p-0">
                    <li (click)="selectCode(null)" class="tw-flex tw-items-center tw-px-4 tw-py-2 hover:tw-bg-gray-100 cursor-pointer tw-justify-between">
                      <div class="tw-flex tw-items-center tw-justify-center tw-w-full">
                        <img [src]="imagesPath + 'xx.svg'" class="tw-h-4 tw-w-4 tw-mr-2">
                        <span> - </span>
                      </div>
                    </li>
                    @for (code of filteredCodes; track code) {
                      <li (click)="selectCode(code)" class="tw-flex tw-items-center tw-px-4 tw-py-2 hover:tw-bg-gray-100 cursor-pointer tw-justify-between">
                        <div class="tw-flex tw-items-center tw-justify-center tw-w-full">
                          <img [src]="imagesPath + code?.code2?.toLowerCase() + '.svg'" alt="{{ code.country }} flag" class="tw-h-4 tw-w-4 tw-mr-2">
                          <span>{{ '+' + code?.code_phone }}</span>
                        </div>
                      </li>
                    }
                  </ul>
                }

                  <!-- Input para el número de celular -->
                  <input class="tw-w-4/5 tw-h-[26px] tw-rounded-md tw-border-none tw-bg-white tw-px-2" type="text" [formControlName]="controlName" placeholder="{{'commons.enter_cellphone' | translate }}" />
                </div>
              </div>

              <!-- errores -->
              @if (form.get('cellphone')?.hasError('invalidPhoneNumber')) {
                <div>
                  <p class="tw-text-red-500">{{'user_management.errors.cellphone' | translate}}</p>
                </div>
              }
              @if (form.get('cellphone')?.hasError('invalidCountryCode')) {
                <div>
                  <p class="tw-text-red-500">{{'user_management.errors.country_code' | translate}}</p>
                </div>
              }
            }

            @case ('birthdate') {
              <label class="tw-text-main-text tw-text-xs" [ngClass]="{'tw-text-detractors' : !form.get(controlName).valid && form.get(controlName).touched }">{{ 'user_management.create_user.personal_info.' + controlName | translate }}</label>
              <input type="date" class="tw-h-[34px] tw-my-2 tw-rounded-md tw-border tw-border-border-light-gray tw-bg-fff disabled:tw-bg-main-disabled disabled:tw-text-disabled-font" lang="us-EN" onkeydown="return false" [formControlName]="controlName" placeholder="MM/DD/YYYY"/>
            }

            <!-- TODO: se puede componetizar despues -->
            @case ('separator') {
              <div class="tw-flex tw-items-center tw-my-1">
                <div class="tw-flex-grow tw-border-t tw-border-gray-300"></div>
                <span class="tw-mx-4 tw-text-gray-500 tw-font-semibold">{{ 'commons.internal_use' | translate }}</span>
                <div class="tw-flex-grow tw-border-t tw-border-gray-300"></div>
              </div>
            }
            <!-- end -->

            @case ('hubspot_id') {
              <label class="tw-text-main-text tw-text-xs">{{ 'user_management.create_user.personal_info.' + controlName | translate }}</label>
              <input class="tw-h-[34px] tw-my-2 tw-rounded-md tw-border tw-border-border-light-gray tw-bg-fff disabled:tw-bg-main-disabled disabled:tw-text-disabled-font" type="text" [formControlName]="controlName"/>
            }

            @case ('user_calendar') {
              <label class="tw-text-main-text tw-text-xs">{{ 'user_management.create_user.personal_info.' + controlName | translate }}</label>
              <input class="tw-h-[34px] tw-my-2 tw-rounded-md tw-border tw-border-border-light-gray tw-bg-fff disabled:tw-bg-main-disabled disabled:tw-text-disabled-font" type="text" [formControlName]="controlName"/>
            }

            @case ('cs_partner') {
              <label class="tw-flex tw-items-center tw-text-main-text tw-text-xs tw-h-full">
                <input type="checkbox" class="tw-mr-2 tw-rounded tw-border tw-border-border-light-gray tw-bg-fff disabled:tw-bg-main-disabled disabled:tw-text-disabled-font tw-w-6 tw-h-6 tw-text-blue-600 " [formControlName]="controlName"/>
                {{ 'user_management.create_user.personal_info.' + controlName | translate }}
              </label>
            }

            @case (controlName === 'email' && personalAdjusts ? controlName : '') {
              <div [mhTooltip]="'user_management.create_user.personal_info.email_not_editable_tooltip' | translate" width="320" position="above">
                <label class="tw-text-main-text tw-text-xs" [ngClass]="{'tw-text-detractors' : !form.get(controlName).valid && form.get(controlName).touched }">{{ 'user_management.create_user.personal_info.' + controlName | translate }}<span class="tw-text-red-500">*</span></label>
                <input class="tw-h-[34px] tw-my-2 tw-rounded-md tw-border tw-border-border-light-gray tw-bg-fff disabled:tw-bg-main-disabled disabled:tw-text-disabled-font tw-w-full" type="text" [formControlName]="controlName" [ngClass]="{'tw-border-detractors' : !form.get(controlName).valid && form.get(controlName).touched }"/>
              </div>
              <p class="tw-text-red-500 tw-text-xs tw-mt-1">{{ 'user_management.create_user.personal_info.email_not_editable_message' | translate }}</p>
            }

            @default {
              <label class="tw-text-main-text tw-text-xs" [ngClass]="{'tw-text-detractors' : !form.get(controlName).valid && form.get(controlName).touched }">{{ 'user_management.create_user.personal_info.' + controlName | translate }}<span class="tw-text-red-500">*</span></label>
              <input class="tw-h-[34px] tw-my-2 tw-rounded-md tw-border tw-border-border-light-gray tw-bg-fff disabled:tw-bg-main-disabled disabled:tw-text-disabled-font" type="text" [formControlName]="controlName" [ngClass]="{'tw-border-detractors' : !form.get(controlName).valid && form.get(controlName).touched }"/>
            }
          }

        </div>
      }
    </div>
    <div class="tw-w-full md:tw-w-1/2 tw-self-center tw-flex tw-flex-col tw-justify-center tw-items-center">
      @if (completenessPercentage) {
        <div class="tw-w-full tw-max-w-xs tw-mb-6">
          @if (completenessPercentage === 100) {
            <div class="tw-text-center tw-mb-3">
              <div class="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-mb-1">
                <span class="tw-text-2xl">🎉</span>
                <p class="tw-text-[18px] tw-font-medium tw-leading-[100%] tw-tracking-normal tw-text-gray-800">
                  {{ 'complete_profile.congratulations' | translate }}
                </p>
              </div>
              <p class="tw-text-[18px] tw-font-medium tw-leading-[100%] tw-tracking-normal tw-text-gray-800">
                {{ 'complete_profile.profile_complete' | translate }}
              </p>
            </div>
          }

          @if (completenessPercentage < 100) {
            <p class="tw-text-center tw-text-[18px] tw-font-medium tw-leading-[100%] tw-tracking-normal tw-text-gray-800 tw-mb-3">
              {{ 'complete_profile.title_short' | translate }}
            </p>
          }

          <div class="tw-flex tw-items-center tw-gap-3">
            <div class="tw-flex-1 tw-h-2 tw-rounded-full tw-bg-gray-200">
              <div
                class="tw-h-2 tw-rounded-full tw-bg-[#2196F3]"
                [style.width.%]="completenessPercentage"
              ></div>
            </div>
            <span class="tw-text-[18px] tw-font-normal tw-leading-[100%] tw-tracking-normal tw-text-gray-800 tw-min-w-[45px]">{{ completenessPercentage | number:'1.0-0' }}%</span>
          </div>

          @if (completenessPercentage < 100 && missingProfileFields.length) {
            <div class="tw-mt-3">
              <p class="tw-text-base tw-font-normal tw-text-gray-700 tw-mb-1">{{ 'complete_profile.missing_fields_title' | translate }}</p>
              <ul class="tw-list-inside tw-text-sm tw-text-red-500 tw-m-0 tw-p-0 tw-capitalize">
                @for (field of missingProfileFields; track field) {
                  <li>{{ field | translate }}</li>
                }
              </ul>
            </div>
          }
        </div>
      }

      <mh-profile-photo #profilePhoto [image]="data?.profile_photo || null" [targetUserId]="data?.id" (changed)="changeProfilePhoto($event)"></mh-profile-photo>
      @if (personalAdjusts) {
        <div class="tw-ml-2">
          <a href="javascript:void(0)" class="tw-underline tw-text-sky-500 hover:tw-text-sky-600"
            [class.tw-opacity-50]="!form.valid" [class.tw-pointer-events-none]="!form.valid" (click)="profilePhoto.fileInput.nativeElement.click()">
            {{ 'user_management.upload_profile_photo' | translate }}
          </a>
        </div>
      }
    </div>
  </div>

  @if (progressRate) {
    <div class="tw-flex tw-justify-center tw-mt-40 tw-gap-5">
      <mh-core-lib-button [isSecondary]="true" [isDisabled]="false" [text]="('commons.back' | translate)" (click)="updateIndexEmit(false)"></mh-core-lib-button>
      <mh-core-lib-button [isDefault]="true" [isDisabled]="!form.valid" [text]="('user_management.create_user.next' | translate)" (click)="updateIndexEmit(true)"></mh-core-lib-button>
    </div>
  } @else {
    <div class="tw-flex tw-justify-center tw-gap-5 tw-pt-3 tw-pb-7">
      <mh-core-lib-button [isSecondary]="true" [text]="('commons.exit_not_save' | translate)" (click)="goToBack()" width="tw-w-fit"></mh-core-lib-button>
      <mh-core-lib-button [isSecondary]="true" [text]="('forms.edit_password' | translate)" (click)="editPassword()" customClass="tw-whitespace-nowrap !tw-px-2 " ></mh-core-lib-button>
      <mh-core-lib-button [isDefault]="true" [isDisabled]="!form.valid" [text]="('commons.save_changes' | translate)" (click)="emitUser()" [customClass]="'tw-bg-sky-500 hover:tw-bg-sky-500'" ></mh-core-lib-button>
    </div>
  }
</form>
